import { Modal } from "@mui/material";
import styled from "styled-components";

export const CookieModal = styled(Modal)`
  & .MuiModal-backdrop {
    background: rgba(46, 46, 46, 0.80);
  }

  &.MuiModal-root{
    z-index: 2000; /* Ensure it appears above other content */
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding:32px;
`;


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 28px;
  padding: 40px;
  max-width: 640px;
  min-width: 300px;
  background-color: #ffffff;
  box-shadow: 0 16px 32px 0 rgba(15, 40, 53, 0.2);
  border-radius: 16px;

@media (max-width: 768px) {
    padding: 20px;
}
`;

export const Title = styled.h1`
  color: #015294;

  /* Header/H4 - Med/Medium */
  font-family: Ubuntu;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px; /* 133.333% */
  letter-spacing: 0;
`;

export const Description = styled.p`
  color: #2e2e2e;

  /* Body/B3 - Medium (Primary)/Regular */
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  margin-bottom: 1rem;
`;

export const Explanation = styled.p`
  color: #2e2e2e;
  font-size: 14px;
  margin-bottom: 1rem;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const Button = styled.button<{ option: "Agree" | "Reject" }>`
  all: unset;

  flex: 1;
    min-width: calc(300px - 40px); 
  cursor: pointer;
  :focus-visible {
    outline: revert;
  }
  box-sizing: border-box;
  text-align: center;

  padding: 14px 16px;
  border-radius: 32px;
  background: ${(props) => (props.option === "Agree" ? "#015294" : "transparent")};
  color: ${(props) => (props.option === "Agree" ? "#fff" : "#015294")};
  ${(props) =>
    props.option === "Reject" &&
    `
    border: 1px solid #015294;
  `}
  /* Button/Medium */
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
`;
